import { createStyles } from '@material-ui/core';
import palette from 'theme/palette';

export default () =>
  createStyles({
    sectionTitle: {
      margin: '32px 8px 16px',
      fontSize: 14,
    },
    switchText: { fontSize: 12, fontWeight: 500 },
    virtualizerSwitch: {
      padding: '0 0 15px 15px',
    },
    formLabel: {
      marginTop: 5,
      marginBottom: 5,
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    ssoContainer: {
      margin: '0 8px',
    },
    bypass: {
      padding: '8px 8px 8px 16px !important',
      display: 'flex',
      alignItems: 'center',
    },
    changePassButton: {
      marginRight: 10,
    },
    clientSecretPassField: {
      '& .MuiOutlinedInput-adornedEnd': {
        padding: 0,
      },
      '& .MuiInputAdornment-root': {
        display: 'none',
      },
    },
  });
